"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var styles = tslib_1.__importStar(require("./PaginationItem.style"));

function PaginationItem(_ref) {
  var children = _ref.children,
      _ref$pageNumber = _ref.pageNumber,
      pageNumber = _ref$pageNumber === void 0 ? 0 : _ref$pageNumber,
      _ref$isArrow = _ref.isArrow,
      isArrow = _ref$isArrow === void 0 ? false : _ref$isArrow,
      _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      onClick = _ref.onClick;

  function handleClick() {
    onClick && onClick(pageNumber);
  }

  return jsx_runtime_1.jsx("li", {
    children: jsx_runtime_1.jsx("button", Object.assign({
      type: "button",
      css: [styles.wrapper(isArrow), active && styles.active],
      onClick: handleClick
    }, {
      children: jsx_runtime_1.jsx("span", Object.assign({
        css: styles.content
      }, {
        children: children
      }), void 0)
    }), void 0)
  }, void 0);
}

exports.default = react_1.memo(PaginationItem);